import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';

import { TransportActionBarWidgetComponent } from './component/transport-action-bar.component';
import { ActionsModule } from '../../../control/actions/actions.module';
import { TransportActionBarModule } from '../../../control/transport-action-bar/transport-action-bar.module';

@NgModule({
  declarations: [
    TransportActionBarWidgetComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MatInputModule,
    MatTooltipModule,
    ApplicationClientCommonModule,
    TransportActionBarModule,
    CommonTranslationModule,
    ActionsModule
  ],
  exports: [
    TransportActionBarWidgetComponent
  ]
})
export class TransportActionBarWidgetModule { }
